import api from "@/lib/api";

const BASE = "/incoming-inspection";

const iiApi = {
  getPartSpec: (partNumber) =>
    api.get(`${BASE}/part-specs/lookup`, { params: { part_number: partNumber } }).then((r) => r.data),
  importPartSpecs: (parts) => api.post(`${BASE}/part-specs/import`, { parts }).then((r) => r.data),
  saveReport: (payload) => api.post(`${BASE}/reports`, payload).then((r) => r.data),
  updateReport: (id, payload) => api.put(`${BASE}/reports/${id}`, payload).then((r) => r.data),
  listReports: (params) => api.get(`${BASE}/reports`, { params }).then((r) => r.data),
  getReport: (id) => api.get(`${BASE}/reports/${id}`).then((r) => r.data),
  listNcrs: (params) => api.get(`${BASE}/ncrs`, { params }).then((r) => r.data),
  getNcrById: (id) => api.get(`${BASE}/ncrs/${encodeURIComponent(id)}`).then((r) => r.data),
  getNcr: (params) => api.get(`${BASE}/ncrs/lookup`, { params }).then((r) => r.data),
  saveNcr: (payload) => api.post(`${BASE}/ncrs`, payload).then((r) => r.data),
};

export default iiApi;
